import React, { useCallback, useEffect, useRef, useState } from 'react'
import * as XLSX from 'xlsx';
import "../assets/css/ZoneMaster.css";
import "../assets/css/global.css";
import { AUTH_CODE, dispatchedHistoryTableHeader, DispatchFilter, path_Operation } from "../constants/constVariables";
import { processData, downloadBulkSearch, downloadData, getPlantValue, postUsageAnalyticsCall } from '../constants/Utils.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { vinsDispatchHistoryAPI, DispatchSearchApi } from '../utils/apiServices';
import Table from "./Table/Table";
import BulkSearchErrorModal from './FormComponents/BulkSearchErrorModal';
import { CustomTab, Select } from '../atomicComponents';
import { APILimit } from '../constants/constVariables';
import BackButton from '../clientComponents/BackButton/BackButton';
import Loader from './Loader';
import BulkSearchModal from './FormComponents/BulkSearchModal';
import ConfirmationModal from "./FormComponents/ConfirmationModal";
import { useAuthorizationContext } from '../providers/AuthorizationHandler/AuthorizationHandler';
import { ErrorModal } from './FormComponents';

export default function DispatchHistory() {

    const filterPlantName = getPlantValue();
    const [bulkSearchButton, setBulkSearchButton] = useState(false);
    const [dispatchList, setdispatchList] = useState([]);
    const [offset, setOffset] = useState(0);
    const [count, setCount] = useState(0);
    const countRef = useRef(0);  // for calculating offset
    const [hasNext, sethasNext] = useState(false);
    const [currentFilter, setcurrentFilter] = useState("all");
    const [currentSearch, setcurrentSearch] = useState("all");
    const [dataPerPage, setDataPerPage] = useState();
    const [totalData, setTotalData] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [checkedState, setCheckedState] = useState([]);
    const [checkedStateAll, setCheckedStateAll] = useState(false);
    const [allSelectedRows, setAllSelectedRows] = useState(false);
    const [loader, setLoader] = useState(false);
    const [columns, setColumns] = useState([]);
    const [data, setData] = useState([]);
    const [dataVIN, setDataVIN] = useState([]);
    const [isModalAlertOpen, setIsModalAlertOpen] = useState(false);
    const [isModalBulkSearchOpen, setIsModalBulkSearchOpen] = useState(false);
    const [isWarningModalOpen, setWarningModalIsOpen] = useState(false);
    const [title, setTitle] = useState({});
    const [vinData, setVinData] = useState([]);
    const [vinsSearch, setVinsSearch] = useState([]);
    const [isbulkDownloaded, setIsBulkDownloaded] = useState(false);
    const [pageLeaveTime, setPageLeaveTime] = useState();
    const [isErrorModalOpen, setErrorModalIsOpen] = useState(false);
    const location = useLocation();
    const { user } = useAuthorizationContext();
    const increaseOffset = useCallback(() => {
        setOffset(offset + 1);
    }, [offset]);

    const resetOffset = useCallback(() => {
        setOffset(0)
    }, [offset]);

    const increaseRef = useCallback(() => {
        countRef.current = countRef.current + 1
    }, [countRef]);

    const resetConfigs = () => {
        setSelectedRows([]);
        countRef.current = 0
        resetOffset()
    }
    const fetchVins = async () => {

        const response = await vinsDispatchHistoryAPI(filterPlantName.value, APILimit, offset, currentFilter, currentSearch);
        setCount(response.data.total_count);
        var data = response.data.data;
        setLoader(true);
        // increaseOffset();
        increaseRef();
        sethasNext(response.data['has_next'])
        setDataPerPage(response.data.count);
        setTotalData(response.data.data.length);
        // console.log("selectedRows = ", selectedRows)
        setSelectedRows([...selectedRows, ...new Array(response.data.data.length).fill(false)])
        if (offset !== 0) {
            let temp = [...dispatchList]
            data.forEach(element => {
                temp.push(element)
            });
            setdispatchList(temp);
        } else {
            setdispatchList(data);
            setVinData(data)
        }
    };

    const openUploadFile = () => {
        document.getElementById('input_file').value = "";
        document.getElementById('input_file').click();
    }

    // handle file upload
    const handleFileUpload = e => {
        const file = e.target.files[0];
        setData([]);
        setColumns([]);
        setDataVIN([]);
        const reader = new FileReader();
        reader.onload = (evt) => {
            /* Parse data */
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
            const dataProcess = processData(data);
            setData(dataProcess[0]);
            setColumns(dataProcess[1]);
        };
        reader.readAsBinaryString(file);
        setIsModalBulkSearchOpen(false);
        setWarningModalIsOpen(true)
        setIsBulkDownloaded(false)
    }

    const clearBulkSearch = () => {
        setdispatchList(vinData);
        setBulkSearchButton(false);
        setSelectedRows([...new Array(vinData.length).fill(false)])

    }

    const handleBulksearch = async () => {
        if (dataVIN.length > 0) {
            const payload = {
                "vin_numbers": dataVIN,
                "plant_id": filterPlantName.value,
            }
            setLoader(false);
            const response = await DispatchSearchApi(payload).then((response) => {
                setBulkSearchButton(true);
                setLoader(true);
                setSelectedRows([...new Array(response.data.data.length).fill(false)])
            setTotalData(response.data.data.length);
            if (response.data.fail_count > 0) {
                setTitle({ ...response.data.fail_list, totalData: response.data.total_count, failedData: response.data.fail_count, });
                setIsModalBulkSearchOpen(false);
                setIsModalAlertOpen(true);
            }
            setdispatchList(response.data.data);
            setLoader(true)
        }).catch((error) => {
            setTitle(error?.response?.data?.message);
            setErrorModalIsOpen(true);
            setLoader(true);
            setBulkSearchButton(false);
        })
        }
        else {
            setLoader(false)
            setdispatchList([]);
        }
    }

    const fetchBulkSearchVins = async () => {
        const searchcolumns = columns.filter((item) => {
            return item.name === "VIN_NUMBER";
        });
        // console.log("column name",searchcolumns);
        if (columns) {
            columns.map((item, index) => {
                // console.log(item.name)
                if (item.name === "VIN_NUMBER") {
                    data.map((item, index) => {
                        dataVIN.push(item.VIN_NUMBER);
                    })
                }
            });
        }
    }

    useEffect(() => { fetchBulkSearchVins() }, [data, columns]);
    useEffect(() => {
        fetchVins();
        setPageLeaveTime(new Date())
    }, ['']);
    useEffect(() => {
        if (countRef.current === 0) {
            fetchVins();
        }
    }, [offset]);
    useEffect(() => { resetConfigs();fetchVins(); }, [currentFilter, currentSearch]);

    useEffect(() => {
        return () => {
            if (new Date() - pageLeaveTime) {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == location?.pathname
                })
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
            }
        }
    }, [pageLeaveTime])
    const browserBack = () => {
        navigate("/");
    }
    const navigate = useNavigate();

    // const handleSearch = (value) => {
    //     if (value === "") {
    //         setcurrentSearch("all")
    //     } else {
    //         setcurrentSearch(value)
    //     }
    // }
    const handleFilterValue = (value) => {
        // console.log("value = ",value,countRef.current)
        setcurrentFilter(value.value);
    }

    const updateSetSelectedRows = async (pos, data, ind) => {
        // console.log("pos = ",pos)
        if (pos == "all") {
            // console.log("pos in parent = ", pos, ind, data)
            setAllSelectedRows(!allSelectedRows)
            // console.log("allSelectedRows",allSelectedRows)
            var ab = dispatchList.map((row, index) => {
                if (ind.includes(index + 1)) {
                    return !allSelectedRows
                }
                return allSelectedRows
            })
            // console.log(" = ", ab)
            setSelectedRows(ab)
        }
        else {
            setSelectedRows(prev => {
                let a = [];
                prev.map((item, index) =>
                    index === pos ? a.push(!item) : a.push(item)
                )
                return [...a];
            });
        }
    }
    // useEffect(() => {
    //     setSelectedRows(new Array(selectedRows.length).fill(allSelectedRows))
    // }, [allSelectedRows])

    const handleCheckbox = (data) => {
        setCheckedStateAll(prev => { return !prev });

    }

    useEffect(() => {
        setCheckedState(prev => {
            return [...new Array(dispatchList.length).fill(checkedStateAll)];
        });
    }, [checkedStateAll])

    // const toggleWarningModal = () => {
    //     setWarningModalIsOpen(false)
    // }
    const handleSingleCheckbox = (position, e) => {
        setCheckedState(prev => {
            let a = [];
            if (prev.length === 0) {
                dispatchList.map((item, index) => index === position ? a.push(true) : a.push(false))
            }
            else {
                prev.map((item, index) =>
                    index === position ? a.push(!item) : a.push(item)
                )
            }
            return [...a];
        });
    };

    return (
        <>
            {
                loader ?
                    <>
                        <div className='breadcrumb'>
                            <BackButton action={"dispatched"} handleClick={browserBack} isbulkDownloaded={isbulkDownloaded} bulkSearchButton={bulkSearchButton} data={dispatchList} />
                        </div>
                        <div className="headerwithcount">
                            <div className='countdiv'>
                                <CustomTab
                                    isSelected={false}
                                    title={"Dispatched Vehicle"}
                                    count={totalData}
                                />
                            </div>

                            <div className="blankdiv">
                                <span className='blankdiv-title mediumFont'>
                                    {"All Dispatched Vehicle (Last 30 Days History)"}
                                </span>
                                <div style={{ marginRight: '10px' }}>
                                    <Select title={"dispatchDropdown"} options={DispatchFilter} onChange={handleFilterValue} selectClassName={"dispatch-history-header-dropdown"} />
                                </div>

                            </div>
                        </div>
                        <div className="blankdiv" >
                            <input
                                type="file"
                                accept=".csv,.xlsx,.xls"
                                id='input_file'
                                onChange={handleFileUpload}
                                hidden
                            />
                        </div>
                        <div className="table-main" style={{ height: window.matchMedia('(max-width:1440px)').matches ? window.innerHeight - 150 : window.innerHeight - 160 }}>
                            <Table
                                columns={[...dispatchedHistoryTableHeader]}
                                defaultColumns={[...dispatchedHistoryTableHeader]}
                                showBulkSearch={true}
                                bulkSearchButton={bulkSearchButton}
                                rowHeight={38}
                                rows={dispatchList}
                                secondaryActions={[
                                    {
                                        name: "Download CSV",
                                        actionFn: () => { setIsBulkDownloaded(true); downloadData(selectedRows, dispatchList, "Dispatch_History") },
                                        authOperation: AUTH_CODE?.DOWNLOAD,
                                        shouldEnable: true,
                                        backgroundColor: '#82C1A7',
                                    },
                                ]}
                                setAsnCount={setCount}
                                removeRowSelection={false}
                                pagination={false}
                                infiniteScroll={false}
                                actionButtons
                                hasNext={hasNext}
                                loadMoreData={() => fetchVins()}
                                // onRowSelect={() => onRowSelect()}
                                onClickPath="/dispatched/vin-details"
                                setTotalData={setTotalData}
                                selectedRows={selectedRows}
                                updateSetSelectedRows={updateSetSelectedRows}
                                // selectCount={selectCount}
                                handleSingleCheckbox={(e) => handleSingleCheckbox(e)}
                                handleCheckbox={(e) => handleCheckbox(e)}
                                downloadBulkSearch={() => downloadBulkSearch()}
                                showBulkSearchMain={() => { setIsModalBulkSearchOpen(true) }}
                                openUploadFile={() => openUploadFile()}
                                clearBulkSearch={() => clearBulkSearch()}
                            />
                            {isModalAlertOpen && <BulkSearchErrorModal open={isModalAlertOpen} handleClose={() => { setIsModalAlertOpen(false); }} Parent="BulkSearch" title={title} />}
                            {isWarningModalOpen && (<ConfirmationModal open={isWarningModalOpen} parent="BulkSearch" handleClose={() => { setWarningModalIsOpen(false) }} confirmDelete={() => handleBulksearch()} />)}
                            {isModalBulkSearchOpen && <BulkSearchModal open={isModalBulkSearchOpen} handleClose={() => { setIsModalBulkSearchOpen(false) }} downloadBulkCsv={() => downloadBulkSearch()} openUploadFile={() => openUploadFile()} title={"title"} />}
                            {<ErrorModal open={isErrorModalOpen} handleClose={() => setErrorModalIsOpen(false)} title={title} />}
                        </div>
                    </>
                    :
                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Loader />
                    </div>
            }
            <style jsx="true">
                {`
                /* Dont move it to any css file, keep it here only */
                @media only screen and (max-width: 768px) {
                    .navbar{
                        display:none;
                    }  
                    #BACK{
                        display: none;
                    }
                    // .mob-secondary-navbar{
                    //     width: calc(100% - 2rem);
                    //     position: fixed;
                    //     left: 0;
                    //     top: 0;
                    // }
                    .mob-secondary-header{
                        background: #F3F5F9;
                        position: fixed;
                        top: 44px;
                        left: 0;
                        width: calc(100% - 1rem);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0.25rem 1rem;
                        font-weight: 600;                        
                        line-height: 19px;
                        color: #707070;
                    } 
                    .mob-secondary-navbar{
                        width: calc(100% - 2rem);
                        top: 0;
                    }
                    .mob-header-heading{
                        display: flex;
                        align-items: center;
                    }
                    .mob-header-heading img{
                        height: 20px;
                        margin-right: 0.5rem;
                    }
                    .dispatch-vin-header{
                        display: none;
                    }
                }
                a {
                    text-decoration: none;
                    color: inherit;
                  }
                
                `}
            </style>
        </>
    )
}